import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import enthoughtLogo from "../../images/enthought.png";
import GithubActivity from "../GithubActivity/GithubActivity";
import ToolsMarquee from "../ToolsMarquee/ToolsMarquee";
import ComputerGraphics from "../OMSCS/ComputerGraphics";
const App = () => {
  const externalLinkIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="0.7em"
      height="0.7em"
      fill="currentColor"
      viewBox="0 0 256 256"
      className="w-3 h-3"
    >
      <path d="M200,64V168a8,8,0,0,1-16,0V83.31L69.66,197.66a8,8,0,0,1-11.32-11.32L172.69,72H88a8,8,0,0,1,0-16H192A8,8,0,0,1,200,64Z"></path>
    </svg>
  );
  const emailIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="currentColor"
      viewBox="0 0 256 256"
      className="w-5 h-5 group-hover:text-red-500 transition-colors"
    >
      <path d="M128,24a104,104,0,0,0,0,208c21.51,0,44.1-6.48,60.43-17.33a8,8,0,0,0-8.86-13.33C166,210.38,146.21,216,128,216a88,88,0,1,1,88-88c0,26.45-10.88,32-20,32s-20-5.55-20-32V88a8,8,0,0,0-16,0v4.26a48,48,0,1,0,5.93,65.1c6,12,16.35,18.64,30.07,18.64,22.54,0,36-17.94,36-48A104.11,104.11,0,0,0,128,24Zm0,136a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" />
    </svg>
  );
  const linkedinIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="currentColor"
      viewBox="0 0 256 256"
      className="w-5 h-5 group-hover:text-blue-600 transition-colors"
    >
      <path d="M216,24H40A16,16,0,0,0,24,40V216a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V40A16,16,0,0,0,216,24Zm0,192H40V40H216V216ZM96,112v64a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0Zm88,28v36a8,8,0,0,1-16,0V140a20,20,0,0,0-40,0v36a8,8,0,0,1-16,0V112a8,8,0,0,1,15.79-1.78A36,36,0,0,1,184,140ZM100,84A12,12,0,1,1,88,72,12,12,0,0,1,100,84Z" />
    </svg>
  );
  const githubIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="currentColor"
      viewBox="0 0 256 256"
      className="w-5 h-5 group-hover:text-purple-600 transition-colors"
    >
      <path d="M208.31,75.68A59.78,59.78,0,0,0,202.93,28,8,8,0,0,0,196,24a59.75,59.75,0,0,0-48,24H124A59.75,59.75,0,0,0,76,24a8,8,0,0,0-6.93,4,59.78,59.78,0,0,0-5.38,47.68A58.14,58.14,0,0,0,56,104v8a56.06,56.06,0,0,0,48.44,55.47A39.8,39.8,0,0,0,96,192v8H72a24,24,0,0,1-24-24A40,40,0,0,0,8,136a8,8,0,0,0,0,16,24,24,0,0,1,24,24,40,40,0,0,0,40,40H96v16a8,8,0,0,0,16,0V192a24,24,0,0,1,48,0v40a8,8,0,0,0,16,0V192a39.8,39.8,0,0,0-8.44-24.53A56.06,56.06,0,0,0,216,112v-8A58.14,58.14,0,0,0,208.31,75.68ZM200,112a40,40,0,0,1-40,40H112a40,40,0,0,1-40-40v-8a41.74,41.74,0,0,1,6.9-22.48A8,8,0,0,0,80,73.83a43.81,43.81,0,0,1,.79-33.58,43.88,43.88,0,0,1,32.32,20.06A8,8,0,0,0,119.82,64h32.35a8,8,0,0,0,6.74-3.69,43.87,43.87,0,0,1,32.32-20.06A43.81,43.81,0,0,1,192,73.83a8.09,8.09,0,0,0,1,7.65A41.72,41.72,0,0,1,200,104Z" />
    </svg>
  );
  const portfolio = (
    <div className="min-h-screen bg-white">
      <div className="w-full max-w-md mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <header className="mb-20">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-thin tracking-tight leading-tight mb-8 text-gray-900">
            Carlos Trejo
          </h1>
          <div className="w-full max-w-md leading-snug text-gray-700 mb-6 text-base md:text-lg">
            <p className="mb-2">
              Senior software engineer with nearly a decade of experience
              delivering full-stack, cloud-native applications from prototype to
              production. I lead client engagements at{" "}
              <a
                href="https://www.enthought.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-orange-400 transition-opacity underline underline-offset-4 decoration-dotted"
              >
                Enthought
              </a>
              , architecting Python, React, and Kubernetes systems for
              enterprise R&D and manufacturing organizations.
            </p>
          </div>
        </header>
        {/* Recent Work */}
        <section className="mb-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-thin mb-8 text-gray-900">
            Recent Work
          </h2>
          <div className="space-y-8">
            <a
              href="https://www.enthought.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block pb-2 border-b border-gray-100 group"
            >
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 items-start sm:items-center">
                <div className="flex-shrink-0 h-14 w-14 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16">
                  <img
                    src={enthoughtLogo}
                    alt="Enthought logo"
                    className="h-full w-full object-contain"
                  />
                </div>
                <div className="flex-1 flex flex-col min-w-0">
                  <h3 className="text-lg font-medium leading-tight">
                    <span className="text-gray-900 hover:opacity-70 transition-opacity inline-flex items-center gap-2">
                      Enthought
                      <span className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-600 text-sm">
                        {externalLinkIcon}
                      </span>
                    </span>
                  </h3>
                  <p className="text-gray-600 leading-tight">
                    Scientific software consultancy building custom computing
                    applications for enterprise R&D and manufacturing. I own
                    architecture and end-to-end delivery on client engagements,
                    from LLM-powered chemical data tools to cross-platform
                    desktop applications and Kubernetes-deployed platforms.
                  </p>
                </div>
              </div>
            </a>
          </div>
        </section>
        {/* Contributions */}
        <section className="mb-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-thin mb-8 text-gray-900">
            Contributions
          </h2>
          <GithubActivity username="carlosdtrejo" />
          <ToolsMarquee />
        </section>
        {/* Experience */}
        <section className="mb-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-thin mb-8 text-gray-900">
            Experience
          </h2>
          <div className="space-y-6">
            {/* Enthought */}
            <div>
              <div className="flex justify-between items-center mb-1">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-3">
                    <div
                      className="w-2 h-2 rounded-full flex-shrink-0 bg-green-500"
                      title="Current Position"
                    ></div>
                    <h3 className="text-lg font-medium m-0">
                      <a
                        href="https://www.enthought.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-900 hover:text-blue-800 transition-opacity flex items-center gap-2 group"
                      >
                        Enthought
                        <span className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-600 text-sm">
                          {externalLinkIcon}
                        </span>
                      </a>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mb-0">
                <p className="text-gray-600 m-0">Senior Software Engineer</p>
                <span className="text-sm text-gray-500">
                  Aug 2026 – Present
                </span>
              </div>
              <div className="flex justify-between items-center mb-0">
                <p className="text-gray-600 m-0">Product Engineer</p>
                <span className="text-sm text-gray-500">
                  Aug 2023 – Aug 2026
                </span>
              </div>
              <p className="text-md text-gray-600 mt-2">
                Technical lead on client engagements, owning architecture and
                end-to-end delivery of scientific computing applications across
                desktop, web, and Kubernetes. Recent work spans an LLM-powered
                application that turns unstructured chemical sources into
                queryable records, a cross-platform desktop app on Rust, Tauri,
                and FastAPI, and a Terraform-provisioned energy management
                platform. Previously built Enthought Edge, a cloud-native
                platform for R&D users, and the Python CLI tooling that
                monitors and audits its clusters.
              </p>
            </div>
            {/* Udemy */}
            <div>
              <div className="flex justify-between items-center mb-1">
                <div className="flex items-center gap-3">
                  <div
                    className="w-2 h-2 rounded-full flex-shrink-0 bg-gray-400"
                    title="Previous Position"
                  ></div>
                  <h3 className="text-lg font-medium m-0">
                    <a
                      href="https://udemy.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-900 hover:text-purple-600 transition-opacity flex items-center gap-2 group"
                    >
                      Udemy
                      <span className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-600 text-sm">
                        {externalLinkIcon}
                      </span>
                    </a>
                  </h3>
                </div>
              </div>
              <div className="flex justify-between items-center mb-0">
                <p className="text-gray-600 m-0">Software Engineer II</p>
                <span className="text-sm text-gray-500">
                  Oct 2021 – Feb 2023
                </span>
              </div>
              <p className="text-md text-gray-600 mt-2">
                Full-stack engineer on the course marketplace, shipping
                statistically significant A/B tests that improved engagement and
                revenue with React, TypeScript, GraphQL, and Django. Led the
                migration of a high-traffic discovery page from the monolith to
                a globally distributed, server-rendered Next.js application, and
                built the Sentry and Datadog dashboards behind it.
              </p>
            </div>
            {/* IBM */}
            <div>
              <div className="flex justify-between items-center mb-1">
                <div className="flex items-center gap-3">
                  <div
                    className="w-2 h-2 rounded-full flex-shrink-0 bg-gray-400"
                    title="Previous Position"
                  ></div>
                  <h3 className="text-lg font-medium m-0">
                    <a
                      href="https://ibm.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-900 hover:text-sky-400 transition-opacity flex items-center gap-2 group"
                    >
                      IBM
                      <span className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-600 text-sm">
                        {externalLinkIcon}
                      </span>
                    </a>
                  </h3>
                </div>
              </div>
              <div className="flex justify-between items-center mb-0">
                <p className="text-gray-600 m-0">Software Developer</p>
                <span className="text-sm text-gray-500">
                  May 2016 – Oct 2021
                </span>
              </div>
              <p className="text-md text-gray-600 mt-2">
                Built the internal GSA Cloud application from the ground up,
                owning the full cycle from concept to production with Perl,
                JavaScript, jQuery, HTML, and CSS. Automated regression testing
                with Selenium WebDriver, Java, Maven, and TestNG, containerizing
                the suite in Docker to run in parallel.
              </p>
            </div>
          </div>
        </section>
        {/* Education */}
        <section className="mb-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-thin mb-8 text-gray-900">
            Education
          </h2>
          <div className="space-y-6">
            {/* Georgia Tech */}
            <div>
              <div className="flex justify-between items-center mb-1">
                <div className="flex items-center gap-3">
                  <div
                    className="w-2 h-2 rounded-full flex-shrink-0 bg-green-500"
                    title="Education"
                  ></div>
                  <h3 className="text-lg font-medium m-0">
                    <a
                      href="https://www.gatech.edu/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-900 hover:text-blue-800 transition-opacity flex items-center gap-2 group"
                    >
                      Georgia Institute of Technology
                      <span className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-600 text-sm">
                        {externalLinkIcon}
                      </span>
                    </a>
                  </h3>
                </div>
              </div>
              <div className="flex justify-between items-center mb-0">
                <p className="text-gray-600 m-0">M.S., Computer Science</p>
                <span className="text-sm text-gray-500">
                  Jan 2025 – Present
                </span>
              </div>
            </div>
            {/* UT Austin */}
            <div>
              <div className="flex justify-between items-center mb-1">
                <div className="flex items-center gap-3">
                  <div
                    className="w-2 h-2 rounded-full flex-shrink-0 bg-gray-400"
                    title="Education"
                  ></div>
                  <h3 className="text-lg font-medium m-0">
                    <a
                      href="https://www.utexas.edu/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-900 hover:text-orange-500 transition-opacity flex items-center gap-2 group"
                    >
                      University of Texas at Austin
                      <span className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-600 text-sm">
                        {externalLinkIcon}
                      </span>
                    </a>
                  </h3>
                </div>
              </div>
              <div className="flex justify-between items-center mb-0">
                <p className="text-gray-600 m-0">B.S., Computer Science</p>
                <span className="text-sm text-gray-500">Dec 2016</span>
              </div>
              <div className="flex justify-between items-center mb-0">
                <p className="text-gray-600 m-0">B.A., Economics</p>
                <span className="text-sm text-gray-500">Dec 2016</span>
              </div>
            </div>
          </div>
        </section>
        {/* Footer */}
        <footer className="pt-8 border-t border-gray-100">
          <div className="flex flex-col sm:flex-row sm:justify-center gap-4 sm:gap-8 lg:gap-24 text-lg text-center sm:text-left">
            <a
              href="mailto:ctrjmtz@duck.com"
              className="inline-flex items-center gap-2 px-4 py-3 text-gray-700 hover:text-red-500 transition-colors underline underline-offset-4 decoration-dotted group"
            >
              {emailIcon} <span className="font-medium">Email</span>
              <span className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-600">
                {externalLinkIcon}
              </span>
            </a>
            <a
              href="https://linkedin.com/in/carlostrejomtz"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-3 text-gray-700 hover:text-blue-600 transition-colors underline underline-offset-4 decoration-dotted group"
            >
              {linkedinIcon} <span className="font-medium">LinkedIn</span>
              <span className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-600">
                {externalLinkIcon}
              </span>
            </a>
            <a
              href="https://github.com/carlosdtrejo"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-3 text-gray-700 hover:text-purple-600 transition-colors underline underline-offset-4 decoration-dotted group"
            >
              {githubIcon} <span className="font-medium">GitHub</span>
              <span className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-600">
                {externalLinkIcon}
              </span>
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
  return (
    <Routes>
      <Route path="/omscs/computer-graphics/*" element={<ComputerGraphics />} />
      <Route path="/*" element={portfolio} />
    </Routes>
  );
};
export default App;
